import {Injectable} from '@angular/core';
import {Reporter} from '../models/models';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class ReporterService {

  constructor(private httpClient: HttpClient) {
  }

  getReporters(): Observable<Reporter[]> {
    return this.httpClient.get<Reporter[]>(environment.baseUrlWs + '/api/reporters');
  }
}
